const rememberCookieConsentGiven = () => {
  window._paq.push(['rememberCookieConsentGiven'])
  // _paq.push(['rememberConsentGiven']);
}

export default rememberCookieConsentGiven
